import { Auditable } from "../auditable";

export enum NetsuiteBatchExportStatus {
  CREATED = "created",
  PROCESSING = "processing",
  SUCCESS = "success",
  ERROR = "error",
}

export enum NetsuiteBatchExportFileFormat {
  CSV = "csv",
  JSON = "json",
  JSON_LINES = "jsonl",
  XML = "xml",
}

export enum NetsuiteBatchExportFileCompression {
  GZIP = "gzip",
}

export interface NetsuiteBatchExport extends Auditable {
  id?: number | null;
  status?: NetsuiteBatchExportStatus | null;
  fromDate?: Date | null;
  toDate?: Date | null;
  sync?: boolean | null;
  startedAt?: Date;
  endedAt?: Date;
  jobId?: string | null;
  error?: string | null;
  numberOfRecords?: number | null;
  fileMd5?: string | null;
  fileMimetype?: string | null;
  fileFormat?: NetsuiteBatchExportFileFormat | null;
  fileStorageKey?: string | null;
  fileCompression?: NetsuiteBatchExportFileCompression | null;
}
